import { combineReducers } from '@reduxjs/toolkit';
import { reducer as allVacationsReducer } from './model/vacations';
import { reducer as selectedVacationReducer } from './model/selectedVacation';

export * as VacationsModel from './model';

const vacationsApplicationsReducer = combineReducers({
  vacations: allVacationsReducer,
  selectedVacation: selectedVacationReducer,
});

export default vacationsApplicationsReducer;
